import { Routes, Route } from 'react-router-dom';
import {
    Container,
    Flag,
    Dimmer,
    Loader,
    Modal,
    Header,
    Icon,
    List,
    Button,
    Message
} from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from '../features/auth/authSlice';


import { useEffect } from 'react';
import { loadConfigInProgress, loadConfigProcessed } from './appSlice'
import { MainNav, getCommonAPI } from 'hpp-fe-common';
import { Navigate } from 'react-router-dom';

import axios from 'axios';

// Component Imports
import Home from '../features/home';
import Loyalty from '../features/loyalty';

// Importing Navigation Config
import mainNavConfig, { addNewLink } from './appNavConfig';



function App() {
    // Checking app state for maintenanceMode
    const maintenanceMode = useSelector(state => state?.app?.maintenanceMode)
    const dispatch = useDispatch();
    // Load app configuration from backend

    useEffect(() => {
        const cancelToken = axios.CancelToken.source()
        dispatch(loadConfigInProgress());

        getCommonAPI().get('/api_v1/config/all?portal=inst', { cancelToken: cancelToken.token })
            .then(({ data }) => {
                if (data.authenticated === false) {
                    return dispatch(signOut())
                }
                dispatch(loadConfigProcessed(data))
            })
            .catch(error => {
                dispatch(loadConfigProcessed({
                    error: true,
                    errorMessage: 'Error in loading configuration. Unable to connect to backend',
                    errorMessageData: error.toString()
                }))
            })
        // Need to load config from backend

        return () => {
            cancelToken.cancel()
        }
    }, [dispatch])

    // Getting country from State
    // const { country } = JSON.parse(window.localStorage.getItem('user'));
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const { country, approved, companyIsActive } = user;

    const { loaded, error, errorMessage, errorMessageData } = useSelector(state => state.app);

    // Getting activeNavID from app state to pass to MainNav component as a prop
    const { activeNavID } = useSelector(state => state.appNavConfig);

    if (approved) {
        addNewLink({ name: 'Loyalty', link: '/loyalty', id: 'loyalty' })
    }

    const countryData = {};
    if (country) {
        countryData.countryName = country.text;
        countryData.countryFlag = <Flag name={country.key} />;
    }

    // If system is under maintainence redirect to maintainence
    if (maintenanceMode) return <Navigate replace to='/maintenance' />

    if (!loaded) return (
        <Dimmer active inverted>
            <Loader inverted>Loading</Loader>
        </Dimmer>
    )

    if (error) return (
        <Modal
            basic
            open={true}
            size='small'
        >
            <Header icon>
                <Icon name='exclamation triangle' />
                {errorMessage}
            </Header>
            <Modal.Content>

                <List bulleted>
                    <List.Item>{errorMessageData}</List.Item>
                </List>
                <Button onClick={() => dispatch(signOut())}>Login Again</Button>
            </Modal.Content>
        </Modal>
    )

    return (
        <Container fluid>
            <MainNav
                activeNavID={activeNavID}
                countryData={countryData}
                mainNavConfig={mainNavConfig}
            />

            {companyIsActive === false && (
                <Message negative style={{ margin: '0', borderRadius: '0' }}>
                    <Message.Header>
                        <Icon name='ban' /> Company Deactivated
                    </Message.Header>
                    <p>
                        Your company has been deactivated. You can view your data but cannot perform
                        transfers, returns or redemptions. Please contact HPL support to reactivate.
                    </p>
                </Message>
            )}

            <Container fluid style={{ padding: '10px 30px' }}>
                <Routes>
                    <Route path='/' element={<Home />} />
                    {approved && <Route path='/loyalty/*' element={<Loyalty />} />}
                </Routes>
            </Container>
        </Container>
    );
}

export default App;
